import { Observable } from 'rxjs';

import { ReportQueryParams, Reports } from '../models/report.model';

export abstract class ReportUsecase {
  abstract get reports$(): Observable<Reports>;

  abstract listReports(params: ReportQueryParams): Observable<never>;
  abstract getReport(projectId: string, version: number): Observable<string>;
}
